import { restApiClient } from '@/datasources';

export async function shareAppointmentByEmail(id: string, email: string) {
  const { data } = await restApiClient.post<void>(`/online/customers/appointments/${id}/share-by-email/`, {
    recipientEmail: email,
  });

  return data;
}
